export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.774922392e8f4a33a9ff564bd3eb70d9.css";